<template>
  <el-menu default-active="1" class="el-menu-demo" mode="horizontal" background-color="#324157" text-color="#fff" active-text-color="#ffd04b">
    <el-menu-item index="1">Stado</el-menu-item>
    <el-menu-item index="4" @click="showAddModal">Dodaj</el-menu-item>
    <el-menu-item index="8" @click="showEditModal">Edytuj</el-menu-item>

    <el-menu-item index="5" @click="getCows('/api/cattle')">Całe stado</el-menu-item>
    <!-- <el-submenu index="6">
      <template slot="title">Krowy</template>
      <el-menu-item index="6-1" @click="getCows('/api/cattle/cows')">Wszystkie</el-menu-item>
      <el-menu-item index="6-2" @click="getCows('/api/cattle/cows/toinsemination')">Do zacielenia</el-menu-item>
      <el-menu-item index="6-3" @click="getCows('/api/cattle/cows/tocheck')">Do sprawdzenia</el-menu-item>
      <el-menu-item index="6-5" @click="getCows('/api/cattle/cows/withcalf')">Cielne</el-menu-item>
      <el-menu-item index="6-6" @click="getCows('/api/cattle/cows/todrying')">Do zasuszenia</el-menu-item>
      <el-menu-item index="6-7" @click="getCows('/api/cattle/cows/dry')">Suche</el-menu-item>
      <el-menu-item index="6-8" @click="getCows('/api/cattle/cows/tocalving')">Do cielenia</el-menu-item>
    </el-submenu> -->
    <!-- <el-submenu index="7">
      <template slot="title">Jałówki</template>
      <el-menu-item index="7-1" @click="getCows('/api/cattle/heifers')">Wszystkie</el-menu-item>
      <el-menu-item index="7-2" @click="getCows('/api/cattle/heifers/toinsemination')">Do zacielenia</el-menu-item>
      <el-menu-item index="7-3" @click="getCows('/api/cattle/heifers/tocheck')">Do sprawdzenia</el-menu-item>
      <el-menu-item index="7-5" @click="getCows('/api/cattle/heifers/withcalf')">Cielne</el-menu-item>
      <el-menu-item index="7-6" @click="getCows('/api/cattle/heifers/tocalving')">Do cielenia</el-menu-item>
    </el-submenu> -->
    <filters-button index="10"/>

    <el-menu-item index="11" @click="print()">Wydruk</el-menu-item>
    <el-menu-item index="3" style="float: right;" @click="goToSettingsPage">
      <i class="fa fa-cog" aria-hidden="true"></i> Ustawienia</el-menu-item>
    <el-menu-item index="9" style="float: right;">
      <el-input class="search-input" placeholder="Szukaj krowy" v-model.lazy="searchQuery"></el-input>
    </el-menu-item>
  </el-menu>
</template>

<script>
import bus from "@/bus";
import lodash from "lodash";
import FiltersButton from "@/components/FiltersButton";

export default {
  data: function() {
    return {
      searchQuery: ""
    };
  },
  watch: {
    searchQuery: lodash.debounce(function(query) {
      this.applyQuery(query);
    }, 500)
  },

  methods: {
    print() {
      bus.$emit("print-page");
    },
    getCows(url) {
      bus.$emit("getCows", url);
    },
    showAddModal() {
      bus.$emit("showAddCowModal");
    },
    showEditModal() {
      bus.$emit("showEditCowModal");
    },
    goToSettingsPage() {
      window.location = "/ustawienia/stada";
    },
    applyQuery: function(query) {
      console.log("idzie sygnal");
      bus.$emit("search-query-send", query);
    }
  },
  components: {
    FiltersButton
  }
};
</script>

<style>

</style>
